import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getDashboardStats } from "../../services/carsService";
import { getCookie } from "../../utils/cookies";
import toast from "../../utils/toast";

function getStoredUserName() {
  try {
    return JSON.parse(getCookie("user"))?.name || "Fleet Owner";
  } catch {
    return "Fleet Owner";
  }
}

export default function Overview() {
  const navigate = useNavigate();
  const [isDashboardData, setDashboardData] = useState();
  const userName = getStoredUserName();

  useEffect(() => {
    fetchDashboardDetail();
  }, []);

  async function fetchDashboardDetail() {
    try {
      const res = await getDashboardStats();
      if (res.success) {
        setDashboardData(res.data || []);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Couldn't load your data.");
    }
  }

  return (
    <>
      <main className="dash-content">
        <section className="dash-section active" data-section="overview">
          <div className="fleet-welcome">
            <div>
              <h1 id="welcomeHeading">Welcome back, {userName} 👋</h1>
              <p>Here's how your fleet is doing today.</p>
            </div>
            <button
              className="btn btn-primary add-car-trigger"
              onClick={() => navigate("/panel/cars")}
            >
              + Add Car
            </button>
          </div>
          <div className="stats-grid stats-grid-4">
            <div className="stat-card">
              <span className="stat-icon">🚗</span>
              <div>
                <strong>{isDashboardData?.totalCars ?? "—"}</strong>
                <span>Total Cars</span>
              </div>
            </div>
            <div className="stat-card">
              <span className="stat-icon">✅</span>
              <div>
                <strong>{isDashboardData?.publishedCars ?? "—"}</strong>
                <span>Published</span>
              </div>
            </div>
            <div className="stat-card">
              <span className="stat-icon">⏳</span>
              <div>
                <strong>{isDashboardData?.pendingCars ?? "—"}</strong>
                <span>Pending</span>
              </div>
            </div>
            <div className="stat-card">
              <span className="stat-icon">🛣️</span>
              <div>
                <strong>{isDashboardData?.totalRoutes ?? "—"}</strong>
                <span>Routes</span>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
